import axios from "axios"

export class NotificationService {
  static async setNotifToken(notificationToken, authToken) {
    return axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/notification/token`,
      {
        token: notificationToken,
      },
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
  }

  static async removeNotifToken(notificationToken, authToken) {
    return axios.delete(
      `${process.env.REACT_APP_API_BASE_URL}/notification/token`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        data: {
          token: notificationToken,
        },
      }
    )
  }

  static async getUserNotifPreferences(authToken) {
    return axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/notification/settings`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
  }

  static async updateUserNotifPreferences(authToken, preferences) {
    return axios.patch(
      `${process.env.REACT_APP_API_BASE_URL}/notification/settings`,
      preferences,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
  }
}
